import { z } from 'zod';
import { CurrencyCode } from '../../../enums/currency.js';
import { enumToZodLiteralUnion } from '../../../zodExtensions.js';
import { variantExchangeLineItem } from '../../schema/claimLineItem.js';
import { Pegasus } from '../../schema/pegasus.js';
export const SHOP_NOW_EXPIRY_SECONDS = 60 * 60;
// TODO: placeholder for pending
export const shopNowIdQueryParam = 'corsoShopNowId';
const totalSchema = z.object({
    amount: z.number(),
    currencyCode: enumToZodLiteralUnion(CurrencyCode),
});
export const shopNowSession = z.object({
    id: z.string(),
    claimId: z.number().optional(),
    returnToCustomerAppUrl: z.string(),
    startShoppingIdUrl: z.string(),
    cancelShoppingIdUrl: z.string(),
    lineItems: z.array(variantExchangeLineItem),
    // the sum of any line_items scheduled to be gift_card or refund
    returnCredit: totalSchema,
    // the offered incentive amount
    returnCreditIncentive: totalSchema,
    returnCreditIncentiveApplied: totalSchema,
    orderIdFromPlatform: z.string().optional(),
    orderNumber: z.string().optional(),
    customerEmail: z.string().optional(),
    createdOn: z.string().optional(),
    completedOn: z.string().optional(),
});
const baseCustomerAppHostConfig = z.object({
    orderIdFromPlatform: z.string(),
});
export const shopNowSessionCreate = shopNowSession
    .pick({
    // configured by the underlying pegasus rule
    returnCreditIncentive: true,
    returnCredit: true,
})
    .extend({
    orderIdFromPlatform: z.string(),
    customerAppHostConfig: z.discriminatedUnion('type', [
        z
            .object({
            type: z.literal('standalone'),
            slug: z.string(),
        })
            .merge(baseCustomerAppHostConfig),
        z
            .object({
            type: z.literal('embedded'),
            parentHostUrl: z.string().url(),
        })
            .merge(baseCustomerAppHostConfig),
    ]),
    shopNowEvent: Pegasus.shopNowEventParams,
});
export const shopNowSessionUpdate = shopNowSession.pick({
    lineItems: true,
    returnCreditIncentiveApplied: true,
});
//# sourceMappingURL=shopNow.js.map